var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRunIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3013",
    "data-name": "Grupo 3013",
    transform: "translate(-30 -499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2439",
    "data-name": "Grupo 2439",
    transform: "translate(-39 606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1288",
    "data-name": "Ret\\xE2ngulo 1288",
    width: 34,
    height: 34,
    rx: 10,
    transform: "translate(69 -107)",
    fill: "#b895ff",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "carbon_clean",
    transform: "translate(34.739 495.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_458",
    "data-name": "Caminho 458",
    d: "M11.6,12.522A2.861,2.861,0,0,0,10.2,10.083l4.326-7.5L13.511,2,9.081,9.673a3.332,3.332,0,0,0-3.065.879C3.828,12.662,4,17.6,4.006,17.807a.585.585,0,0,0,.585.561h8.763a.585.585,0,0,0,.351-1.052C11.635,15.763,11.6,12.554,11.6,12.522ZM8.635,10.767a1.818,1.818,0,0,1,1.8,1.755c0,.022,0,.122.01.274L6.993,11.262a2.221,2.221,0,0,1,1.642-.5ZM10.693,17.2a3.04,3.04,0,0,1-.848-1.754H8.676A3.8,3.8,0,0,0,9.242,17.2h-1.3a9.717,9.717,0,0,1-.435-2.338H6.338A10.137,10.137,0,0,0,6.727,17.2H5.169a11.668,11.668,0,0,1,1.054-5l4.4,1.958A7.614,7.614,0,0,0,11.948,17.2Z",
    transform: "translate(3 10)",
    fill: "#b895ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunIcon);
export default __webpack_public_path__ + "static/media/runIcon.45e692161332c5be17e42c7b4cbac013.svg";
export { ForwardRef as ReactComponent };